module.exports = __webpack_public_path__ + "media/images/products/wedding/img-feature-schedule-06a6f7f55aca395f1c3e569c0b0d6dc2.png";